<template>
  <v-card class="no-border main-card fill-height">
    <v-card-text>
      <v-layout row wrap class="mb-3">
        <v-flex class="xs12 md9 lg9 mb-2">
          <h3>
            Note:
          </h3>
	  <p>At most 1 API key per environment (Test/Production) can be obtained.</p>
        </v-flex>
        <v-flex class="xs12 md3 lg3 text-xs-right">
          <v-btn
            v-if="show_form === false"
            :disabled="disabledGenerateKeys"
            class="common-btn"
            @click="show_form = true"
            >Request API key</v-btn
          >
        </v-flex>
      </v-layout>
      <div v-if="show_form">
        <v-layout v-if="!show_confirm_form" row wrap>
          <v-flex class="xs12 md12 lg12">
            <v-card
              class="thin-border pa-4"
              style="padding-bottom: 8px !important;"
            >
              <h3 class="confirm-title">Request for new API key</h3>
              <v-text-field
                v-model="api_form.name"
                label="Username"
                name="username"
                value="Username"
                autocomplete="off"
                :disabled="true"
              ></v-text-field>
              <v-select
                v-model="api_form.environment"
                :items="environmentList"
                item-value="value"
                item-text="name"
                menu-props="auto"
                hide-details
                label="Select environment"
                single-line
                class="select-list"
                @change="environmentListSelectChange"
              ></v-select>
              <v-text-field
                v-model="api_form.max_accounts"
                label="Max accounts"
                name="max_accounts"
                value="Max accounts"
                autocomplete="off"
                :disabled="true"
              ></v-text-field>
              <div class="text-xs-right">
                <v-btn
                  class="mx-0 my-3 common-btn"
                  :disabled="disabledGenerateKey"
                  @click="show_confirm_form = true"
                  >Request API key</v-btn
                >
                <v-btn
                  class="mx-0 my-3 btn-cancel"
                  style="color: #103a84 !important"
                  @click="show_form = false"
                  >Cancel</v-btn
                >
              </div>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap>
          <v-flex class="xs12 md12 lg12">
            <v-card
              class="thin-border pa-4"
              style="padding-bottom: 8px !important;"
            >
              <h3 class="confirm-title">Confirm your request</h3>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Username
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ api_form.name }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Environment
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ api_form.environment }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Max accounts
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ api_form.max_accounts }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <div class="text-xs-right">
                <v-btn class="mx-0 my-3 common-btn" @click="createApikey"
                  >Confirm</v-btn
                >
                <v-btn
                  class="mx-0 my-3 btn-cancel"
                  style="color: #103a84 !important"
                  @click="show_confirm_form = false"
                  >Back</v-btn
                >
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
      <div v-else class="keys">
        <h3>API keys:</h3>
        <v-layout
          v-for="api_key in api_keys"
          :key="api_key.api_key"
          row
          wrap
          style="border: 1px solid #e6efff; border-radius: 10px; padding: 16px; margin-bottom: 8px;"
        >
          <v-flex md6 xs12>
            <v-layout row wrap>
              <v-flex md4 xs6>
                Environment:
              </v-flex>
              <v-flex md8 xs6>
                {{ api_key.environment }}
              </v-flex>
              <v-flex md3 xs5>
                Key:
              </v-flex>
              <v-flex md1 xs1>
                <img
                  width="24"
                  height="24"
                  :src="
                    !api_key.show_api_key
                      ? '/img/eye-icon-' + themeMode + '.svg'
                      : '/img/eye-open-icon-' + themeMode + '.svg'
                  "
                  @click="api_key.show_api_key = !api_key.show_api_key"
                />
              </v-flex>
              <v-flex md8 xs6 style="word-wrap: break-word;">
                {{
                  api_key.show_api_key
                    ? api_key.api_key
                    : api_key.api_key.substring(0, 5).concat("***")
                }}
              </v-flex>
              <v-flex md3 xs5>
                Secret:
              </v-flex>
              <v-flex md1 xs1>
                <img
                  width="24"
                  height="24"
                  :src="
                    !api_key.show_api_secret
                      ? '/img/eye-icon-' + themeMode + '.svg'
                      : '/img/eye-open-icon-' + themeMode + '.svg'
                  "
                  @click="api_key.show_api_secret = !api_key.show_api_secret"
                />
              </v-flex>
              <v-flex md8 xs6 style="word-wrap: break-word;">
                {{
                  api_key.show_api_secret
                    ? api_key.api_secret
                    : api_key.api_secret.substring(0, 5).concat("***")
                }}
              </v-flex>
              <v-flex md4 xs6> Created at: </v-flex>
              <v-flex md8 xs6>
                {{ api_key.created_at_utc | formatDate("DD MMM YYYY HH:mm") }} {{timeZone}}
              </v-flex>
              <v-flex md4 xs6>
                Accounts:
                <v-icon
                  class="vertical-align-middle icon-for-information"
                  style="font-size: 14px;"
                  @click="
                    () => {
                      infoAlert(
                        $t('information.whitelabel_max_accounts.title'),
                        $t('information.whitelabel_max_accounts.description')
                      );
                    }
                  "
                >fa-info-circle</v-icon>
              </v-flex>
              <v-flex md8 xs6>
                {{ api_key.environment === "Test" ? '-' : api_key.current_accounts }}/{{ api_key.max_accounts }}
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6 xs12>
            <v-switch
              v-model="api_key.is_active"
              :label="api_key.is_active ? `Enabled` : `Disabled`"
              class="switch"
              @change="changedKeyStatus(api_key.api_key, api_key.is_active, api_key.environment)"
            ></v-switch>
            <span v-if="api_key.request_sent" class="request-sent">
              Request sent, this may take up 15 minutes to process
            </span>
          </v-flex>
        </v-layout>
        <v-layout v-if="api_keys == null || api_keys.length === 0" row wrap>
          <v-flex class="xs12 md12 lg12">
            <p style="margin-top: 20px;">
              You have no API keys yet.
            </p>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.request-sent {
  color: #db4a36;
  font-size: 12px;
}
>>> .btn-cancel {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84 !important;
  background: #e6efff !important;
  border-radius: 30px;
  width: 147px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
.common-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
.theme--light p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #103a84;
}
.theme--light .confirm-title {
  color: #103a84;
}
.theme--light h3 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #103a84;
}
.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--light .keys {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #103a84;
}
.theme--light .thin-border {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
}
.theme--light .switch >>> .v-label {
  color: #103a84;
}
.theme--light >>> .v-label {
  color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
>>> .theme--light .v-input__slot::before {
  border-color: #b8d2ff !important;
}
>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  width: 196px;
  height: 44px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}

>>> .theme--light.v-input input::placeholder,
>>> .theme--light.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #7395d0;
}
>>> .theme--light .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  /*font-size: 18px;*/
  /*line-height: 22px;*/
  color: #103a84;
}
/*************************************************************/
.theme--dark p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #ffffff;
}
.theme--dark .confirm-title {
  color: #ffffff;
}
.theme--dark .main-card {
  background: #212121;
  box-shadow: none;
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--dark h3 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
.theme--dark .keys {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
.theme--dark .thin-border {
  border: 1px solid #9e9e9e;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
  background: #212121;
}
.theme--dark .switch >>> .v-label {
  color: #ffffff;
}
.theme--dark >>> .v-label {
  color: #b8d2ff;
}
>>> .theme--dark.v-input:not(.v-input--is-disabled) input,
>>> .theme--dark.v-input:not(.v-input--is-disabled) textarea {
  color: #ffffff;
}
>>> .theme--dark .v-input__slot::before {
  border-color: #ffffff !important;
}

>>> .theme--dark.v-input input::placeholder,
>>> .theme--dark.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--dark .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--dark .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
>>> .theme--dark .v-list {
  background: #212121;
}
</style>

<script>
import swal from "sweetalert2";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import Vue from "vue";

export default {
  data() {
    return {
      show_form: false,
      show_confirm_form: false,
      form: {
        name: "",
        environment: "Test",
        max_accounts: 2
      },
      environmentList: [
        { value: "Test", name: "Test" },
        { value: "Production", name: "Production" }
      ],
      windowWidth: window.innerWidth
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode",
      user: "auth/user",
      keys: "whitelabel/api_keys"
    }),
    api_form: {
      get: function() {
        if (this.keys) {
          if (this.keys.filter(x => x.environment === "Test").length >= 1) {
            this.form.environment = "Production";
            this.form.max_accounts = 10;
            return this.form;
          }
        }
        return this.form;
      }
    },
    disabledGenerateKey: function() {
      if (this.api_form.environment === "Test") {
        return this.keys.filter(x => x.environment === "Test").length >= 1;
      } else if (this.api_form.environment === "Production") {
        return (
          this.keys.filter(x => x.environment === "Production").length >= 1
        );
      }
      return true;
    },
    disabledGenerateKeys() {
      if (this.keys) {
        return (
          this.keys.filter(x => x.environment === "Test").length >= 1 &&
          this.keys.filter(x => x.environment === "Production").length >= 1
        );
      }
      return false;
    },
    timeZone: function() {
      return moment()
        .tz(moment.tz.guess())
        .format("z");
    },
    api_keys() {
      if (this.keys) {
        return this.keys.map(function(key) {
          Vue.set(key, "show_api_key", false);
          Vue.set(key, "show_api_secret", false);
          Vue.set(key, "request_sent", false);
          return key;
        });
      }
      return null;
    },
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    tableHeaders() {
      if (this.isMobile) {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          }
        ];
      } else {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          },
          { text: "Amount", value: "value_cur" },
          { text: "Currency", value: "cur" },
          { text: "USD worth", value: "value_usd" }
        ];
      }
    }
  },
  mounted: async function() {},
  created: async function() {
    if (this.user) {
      this.form.name = this.user.name;
    }
    await this.$store.dispatch("whitelabel/fetchApiKeys");
  },
  methods: {
    changedKeyStatus: async function(key, status, environment) {
      try {
        await axios
          .post("/api/v1/apikeys/change-status", {
            key: key,
            status: status,
            environment: environment,
          })
          .then(async response => {
            if (response.data.status === false) {
              await this.errorAlert();
            } else {
              for (let i = 0; i < this.api_keys.length; i++) {
                if (this.api_keys[i].api_key === key) {
                  this.$set(this.api_keys[i], "request_sent", true);
                }
              }
            }
          })
          .catch(async error => {
            await this.errorAlert();
            await this.$store.dispatch("whitelabel/fetchApiKeys");
          });
      } catch (error) {
        await this.errorAlert();
      }
    },
    createApikey: async function() {
      try {
        await axios
          .post("/api/v1/apikeys/create", {
            name: this.api_form.name,
            environment: this.api_form.environment,
            max_accounts: this.api_form.max_accounts
          })
          .then(async response => {
            if (response.data.status === true) {
              await swal({
                title: "API key request ",
                text: "API key request sent successfully",
                showCloseButton: true,
                imageUrl: "/img/popup_img_success.png",
                customClass: this.themeDark
                  ? "swal-type-success-dark"
                  : "swal-type-success",
                imageHeight: 80,
                imageWidth: 80
              });

              this.show_form = false;
              this.show_confirm_form = false;
              this.$store.dispatch("auth/refreshUserHistory");
            } else {
              await this.errorAlert();
            }
          })
          .catch(async error => {
            await this.errorAlert();
          });
      } catch (error) {
        await this.errorAlert();
      }
    },
    async errorAlert() {
      await swal({
        title: "Problem with API key",
        html: "Please try again later.",
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark
          ? "swal-type-error-dark"
          : "swal-type-error",
        imageUrl: "/img/popup_img_error.png",
        imageHeight: 80,
        imageWidth: 80
      });
    },
    environmentListSelectChange() {
      if (this.api_form.environment === "Test") {
        Vue.set(this.form, "max_accounts", 2);
      } else if (this.form.environment === "Production") {
        Vue.set(this.form, "max_accounts", 10);
      } else {
        Vue.set(this.form, "max_accounts", 0);
      }
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/whitelabel/Apikeys.vue